import styled from 'styled-components';
import { RadioInputOption } from 'src/components/Input/RadioInput/RadioInput';
import {
  RadioButton,
  RadioInput,
} from 'src/components/Input/RadioInput/RadioInput.style.ts';

export const InvertedRadioOption = styled(RadioInputOption)`
color: ${(props) => (props.disabled ? props.theme.black[40] : props.theme.black[70])};
${RadioButton} {
  border: 0.15em solid
    ${(props) => (props.disabled ? props.theme.black[40] : props.theme.black[70])};
  background: ${(props) => (props.checked ? props.theme.black[70] : '')};
  ${RadioInput}:focus + & {
    ${(props) => props.theme.focusBoxShadow};
  }
}
`;
